import { render } from "./TvmSlideOutBbTradeValue.vue?vue&type=template&id=43bda220&scoped=true"
import script from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"
export * from "./TvmSlideOutBbTradeValue.vue?vue&type=script&lang=js"

import "./TvmSlideOutBbTradeValue.vue?vue&type=style&index=0&id=43bda220&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43bda220"],['__file',"src/components/ChatWidget/SlideOutPanel/TvmSlideOutBbTradeValue/TvmSlideOutBbTradeValue.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43bda220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43bda220', __exports__)) {
    api.reload('43bda220', __exports__)
  }
  
  module.hot.accept("./TvmSlideOutBbTradeValue.vue?vue&type=template&id=43bda220&scoped=true", () => {
    api.rerender('43bda220', render)
  })

}


export default __exports__